import { combineReducers } from 'redux';
import { combineActions, handleActions } from 'redux-actions';
import * as actionTypes from './constants';

// If the call itselfs gives a 500, catch it.
export const generalError = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.CREATE_DRAFT_ORDERS,
      actionTypes.CREATE_DRAFT_ORDERS_SUCCESS,
      actionTypes.CREATE_AUTO_ORDERS,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION,
      actionTypes.CREATE_AUTO_ORDERS_SUCCESS,
      actionTypes.DELETE_ORDERS,
      actionTypes.DELETE_ORDERS_SUCCESS,
    )]: () => ({}),
    [combineActions(
      actionTypes.CREATE_DRAFT_ORDERS_FAILURE,
      actionTypes.CREATE_AUTO_ORDERS_FAILURE,
      actionTypes.DELETE_ORDERS_FAILURE,
    )]: (state, { payload }) => payload.error,
    [actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_FAILURE]: (state, { payload }) => (
      {
        type: 'ActionError',
        status: 400,
        errors: payload.error.errors,
      }
    ),
  },
  {},
);

export const isLoading = handleActions(
  {
    [combineActions(
      actionTypes.CREATE_DRAFT_ORDERS_SUCCESS,
      actionTypes.CREATE_DRAFT_ORDERS_FAILURE,
      actionTypes.CREATE_AUTO_ORDERS_SUCCESS,
      actionTypes.CREATE_AUTO_ORDERS_FAILURE,
      actionTypes.DELETE_ORDERS_SUCCESS,
      actionTypes.DELETE_ORDERS_FAILURE,
      actionTypes.AUTO_PLANNING_ACTION_SUCCESS,
      actionTypes.AUTO_PLANNING_ACTION_FAILURE,
      actionTypes.CREATE_AUTO_TICKETS_SUCCESS,
      actionTypes.CREATE_AUTO_TICKETS_FAILURE,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.CREATE_DRAFT_ORDERS,
      actionTypes.CREATE_AUTO_ORDERS,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION,
      actionTypes.DELETE_ORDERS,
      actionTypes.AUTO_PLANNING_ACTION,
      actionTypes.CREATE_AUTO_TICKETS,
    )]: () => true,
  },
  false,
);

// As the drafts are processed in multiple calls,
// one call can fail.
export const singleErrors = handleActions(
  {
    [combineActions('LOCATION_CHANGE', actionTypes.CREATE_DRAFT_ORDERS)]: () => [],
    [combineActions(actionTypes.CREATE_SINGLE_ORDER_FAILURE)]: (state, { payload }) => [
      ...state,
      payload.error,
    ],
  },
  [],
);

export const deleteSuccess = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.DELETE_ORDERS,
      actionTypes.DELETE_ORDERS_FAILURE,
      actionTypes.RESET_DELETE_SUCCESS,
    )]: () => false,
    [combineActions(actionTypes.DELETE_ORDERS_SUCCESS)]: () => true,
  },
  false,
);

export const isCreating = handleActions(
  {
    [combineActions(
      actionTypes.CREATE_DRAFT_ORDERS,
      actionTypes.CREATE_AUTO_ORDERS,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION,
      actionTypes.DELETE_ORDERS,
      actionTypes.CREATE_AUTO_TICKETS,
    )]: () => true,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_SUCCESS,
      actionTypes.CREATE_DRAFT_ORDERS_SUCCESS,
      actionTypes.CREATE_AUTO_ORDERS_SUCCESS,
      actionTypes.CREATE_DRAFT_ORDERS_FAILURE,
      actionTypes.CREATE_AUTO_ORDERS_FAILURE,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_FAILURE,
      actionTypes.DELETE_ORDERS_SUCCESS,
      actionTypes.DELETE_ORDERS_FAILURE,
      actionTypes.CREATE_AUTO_TICKETS_SUCCESS,
      actionTypes.CREATE_AUTO_TICKETS_FAILURE,
    )]: () => false,
  },
  false,
);

export const createSuccess = handleActions(
  {
    [combineActions(
      actionTypes.CREATE_DRAFT_ORDERS_SUCCESS,
      actionTypes.CREATE_AUTO_ORDERS_SUCCESS,
      actionTypes.CREATE_AUTO_TICKETS_SUCCESS,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_SUCCESS,
    )]: () => true,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.CREATE_DRAFT_ORDERS,
      actionTypes.CREATE_AUTO_ORDERS,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION,
      actionTypes.CREATE_DRAFT_ORDERS_FAILURE,
      actionTypes.CREATE_AUTO_ORDERS_FAILURE,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_FAILURE,
      actionTypes.CREATE_AUTO_TICKETS_FAILURE,
      actionTypes.CREATE_AUTO_TICKETS,
    )]: () => false,
  },
  false,
);

export const successCreateIds = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.CREATE_DRAFT_ORDERS,
      actionTypes.CREATE_DRAFT_ORDERS_FAILURE,
    )]: () => [],
    [actionTypes.CREATE_DRAFT_ORDERS_SUCCESS]: (state, { payload }) => payload,
  },
  [],
);

export const autoPlanningInfo = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.AUTO_PLANNING_ACTION,
      actionTypes.AUTO_PLANNING_ACTION_FAILURE,
    )]: () => ({}),
    [actionTypes.AUTO_PLANNING_ACTION_SUCCESS]: (state, { payload }) => ({
      totalCount: payload.totalCount,
      failedCount: payload.failedCount,
      succeededCount: payload.succeededCount,
      failedIds: payload.failedIds,
    }),
  },
  {},
);

export const selectedRowAction = handleActions(
  {
    LOCATION_CHANGE: () => ({}),
    [actionTypes.SET_SELECTED_ROW_ACTION]: (state, { payload }) => payload,
  },
  {},
);

export const autoTotal = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.CREATE_AUTO_ORDERS,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION,
      actionTypes.CREATE_AUTO_ORDERS_FAILURE,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_FAILURE,
      actionTypes.CREATE_AUTO_TICKETS,
      actionTypes.CREATE_AUTO_TICKETS_FAILURE,
      actionTypes.DELETE_ORDERS,
      actionTypes.DELETE_ORDERS_FAILURE,
    )]: () => 0,
    [combineActions(
      actionTypes.CREATE_AUTO_ORDERS_SUCCESS,
      actionTypes.DELETE_ORDERS_SUCCESS,
      actionTypes.CREATE_AUTO_TICKETS_SUCCESS,
    )]: (state, { payload }) => payload.total,
    [actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_SUCCESS]: (state, { payload }) => payload.totalCount,
  },
  0,
);

export const autoFaulty = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.CREATE_AUTO_ORDERS,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION,
      actionTypes.CREATE_AUTO_ORDERS_FAILURE,
      actionTypes.DELETE_ORDERS,
      actionTypes.DELETE_ORDERS_FAILURE,
      actionTypes.CREATE_AUTO_TICKETS,
      actionTypes.CREATE_AUTO_TICKETS_FAILURE,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_FAILURE,
    )]: () => 0,
    [combineActions(
      actionTypes.CREATE_AUTO_ORDERS_SUCCESS,
      actionTypes.DELETE_ORDERS_SUCCESS,
    )]: (state, { payload }) => payload.faulty,
    [combineActions(
      actionTypes.CREATE_AUTO_TICKETS_SUCCESS,
    )]: (state, { payload }) => payload.failed?.length,
    [actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_SUCCESS]: (state, { payload }) => payload.failedCount,
  },
  0,
);

export const autoDraftFailed = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.CREATE_AUTO_ORDERS,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION,
      actionTypes.CREATE_AUTO_ORDERS_FAILURE,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_FAILURE,
    )]: () => [],
    [actionTypes.CREATE_AUTO_ORDERS_SUCCESS]: (state, { payload }) => payload.draftFailed,
    [actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_SUCCESS]: (state, { payload }) => payload.failed,
  },
  [],
);

export const autoCreateFailed = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.CREATE_AUTO_ORDERS,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION,
      actionTypes.CREATE_AUTO_ORDERS_FAILURE,
      actionTypes.CREATE_AUTO_TICKETS,
      actionTypes.CREATE_AUTO_TICKETS_FAILURE,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_FAILURE,
    )]: () => [],
    [actionTypes.CREATE_AUTO_ORDERS_SUCCESS]: (state, { payload }) => payload.createFailed,
    [actionTypes.CREATE_AUTO_TICKETS_SUCCESS]: (state, { payload }) => payload.failed,
    [actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_SUCCESS]: () => [],
  },
  [],
);

export const errors = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.CREATE_AUTO_ORDERS,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION,
      actionTypes.CREATE_AUTO_ORDERS_FAILURE,
      actionTypes.DELETE_ORDERS,
      actionTypes.DELETE_ORDERS_FAILURE,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_FAILURE,
    )]: () => [],
    [combineActions(
      actionTypes.CREATE_AUTO_ORDERS_SUCCESS,
      actionTypes.DELETE_ORDERS_SUCCESS,
    )]: (state, { payload }) => payload.errors,
    [actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_SUCCESS]: () => [],
  },
  [],
);

export const planningBlocks = handleActions(
  {
    [actionTypes.CREATE_AUTO_ORDERS_SUCCESS]: (state, { payload }) => payload.planningBlocks,
    [combineActions(
      actionTypes.CREATE_AUTO_ORDERS,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_SUCCESS,
      actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_FAILURE,
    )]: () => [],
  },
  [],
);

export default combineReducers({
  generalError,
  singleErrors,
  isCreating,
  successCreateIds,
  autoTotal,
  autoFaulty,
  autoDraftFailed,
  autoCreateFailed,
  errors,
  deleteSuccess,
  createSuccess,
  autoPlanningInfo,
  selectedRowAction,
  isLoading,
  planningBlocks,
});
